import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { CollaboratorPublic } from './useCollaboratorsPublicQuery';

async function fetchResponsiblePublic(collaboratorId?: string): Promise<CollaboratorPublic | null> {
    if (!collaboratorId) return null;

    const collaboratorRef = doc(db, 'collaborators_public', collaboratorId);
    const collaboratorSnap = await getDoc(collaboratorRef);

    if (!collaboratorSnap.exists()) return null;

    const collaboratorData = collaboratorSnap.data() as CollaboratorPublic | undefined;
    if (!collaboratorData?.responsibleId) return null;

    const responsibleRef = doc(db, 'collaborators_public', collaboratorData.responsibleId);
    const responsibleSnap = await getDoc(responsibleRef);

    if (!responsibleSnap.exists()) return null;

    const responsibleData = responsibleSnap.data() as CollaboratorPublic | undefined;
    if (!responsibleData) return null;

    return { ...responsibleData, id: responsibleSnap.id };
}

export function useResponsibleEmailQuery(collaboratorId?: string) {
    return useQuery<string | null>({
        queryKey: ['responsible_email', collaboratorId],
        queryFn: async () => (await fetchResponsiblePublic(collaboratorId))?.email ?? null,
        enabled: Boolean(collaboratorId),
        staleTime: 10 * 60 * 1000,
    });
}

export function useResponsibleCollaboratorQuery(collaboratorId?: string) {
    return useQuery<CollaboratorPublic | null>({
        queryKey: ['responsible_collaborator', collaboratorId],
        queryFn: () => fetchResponsiblePublic(collaboratorId),
        enabled: Boolean(collaboratorId),
        staleTime: 10 * 60 * 1000,
    });
}
